module.exports = __webpack_public_path__ + "img/fifth4.658d5a0e.png";